import { Id } from 'types'

interface UpdateObjectProps<T> {
  objects: T[]
  selectedIds: Id[]
  updateProperty: string // Property to update (status, progress, etc.)
  updateValue: string // Value to assign to the updated property
}

export function updateObject<T>(props: UpdateObjectProps<T>): T[] {
  const { objects, selectedIds, updateProperty, updateValue } = props

  return objects.map((object: any) => {
    if (selectedIds.includes(object.id)) {
      return { ...object, [updateProperty]: updateValue }
    }
    return object
  })
}
